import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "loadingFallback", "errorFallback", "subjectId"];
import React, { Suspense } from 'react';
import ErrorBoundary from '../error-boundary';
export var ErrorBoundarySuspense = function ErrorBoundarySuspense(_ref) {
  var children = _ref.children,
    loadingFallback = _ref.loadingFallback,
    _ref$errorFallback = _ref.errorFallback,
    errorFallback = _ref$errorFallback === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : _ref$errorFallback,
    subjectId = _ref.subjectId,
    errorBoundaryProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ErrorBoundary, _extends({
    fallbackUI: errorFallback,
    subjectId: subjectId
  }, errorBoundaryProps), /*#__PURE__*/React.createElement(Suspense, {
    fallback: loadingFallback
  }, children));
};